module.exports = __webpack_public_path__ + "amcharts/images/pencilIcon.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/pencilIcon.png
// module id = 277
// module chunks = 0